export default function LayoutEditorTemplate(data) {
    //language=HTML
    return `
        <div>
            <style>
                form {
                    display: inline-block;
                    width: 100%;
                }

                #layoutEditor {
                    overflow: auto;
                }

                body {
                    background-image: none;
                }

                #props {

                }

                #modifyGridBlockDialog .k-list-item {
                    line-break: anywhere;
                }
            </style>
            <div class="d-flex justify-content-between bg-dark" style="width: 100%;height: 95vh;">
                <div id="layoutEditor" class="d-flex m-0"></div>
                <div id="props" style="width: 25%;direction: ltr;overflow: auto" class="d-flex flex-column bg-light">
                    <div class="d-flex justify-content-between align-items-center" style="background-color: #69696b;text-align: center">
                        <h3 class="text-light m-2">Properties Panel</h3>
                        <h5 class="text-light m-2" id="pointerName"></h5>
                    </div>
                </div>
            </div>
        </div>`;
}